import 'weakmap-polyfill';

import Draggable from './draggable';

function install(Vue) {
    Vue.directive('v-draggable-core', Draggable);
}

export {Draggable, install};

export * from './draggable';

export default Draggable;
